import { Modal, Button, Form } from "react-bootstrap";

const EditStages = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      className="stage-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Stage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          <Form.Group>
            <Form.Label>Stage Name *</Form.Label>
            <Form.Control />
          </Form.Group>

          <div className="footer-actions mt-4">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-orange">Add Stage</Button>
          </div>

        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditStages;